import {useEffect} from 'react';
import {SITE_URL, SOCIAL_LINKS} from '@/config/site';
import {PUBLIC_CONTACTS} from '@/config/contacts';

// Adds one JSON-LD block to <head> (captured by the prerender snapshot) and removes it on unmount.
export const JsonLd = ({id, data}) => {
  const json = JSON.stringify(data);
  useEffect(() => {
    if (!json) return undefined;
    document.getElementById(id)?.remove();
    const el = document.createElement('script');
    el.type = 'application/ld+json'; el.id = id; el.textContent = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [id, json]);
  return null;
};

export const siteOrigin = () => SITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://syntheticmediainvestigator.com');

export const organizationLd = () => {
  const origin = siteOrigin();
  return {
    '@context': 'https://schema.org', '@type': 'Organization', '@id': `${origin}/#organization`,
    name: 'Synthetic Media Investigator', alternateName: 'SMI', url: `${origin}/`, logo: `${origin}/logo.png`,
    ...(PUBLIC_CONTACTS.sales ? {email: PUBLIC_CONTACTS.sales} : {}), areaServed: 'San Francisco Bay Area and remote',
    sameAs: SOCIAL_LINKS.map(s => s.href).filter(h => h && h.startsWith('http')),
  };
};

export const websiteLd = () => {
  const origin = siteOrigin();
  return {'@context': 'https://schema.org', '@type': 'WebSite', '@id': `${origin}/#website`, name: 'Synthetic Media Investigator', url: `${origin}/`, publisher: {'@id': `${origin}/#organization`}};
};
